<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 class="font-size--24" style="word-break: keep-all">
        365 오전 선정산을 위해 필요한 자료들을 체크하고 있습니다.<br />
        <br />
        카드사 변경까지 모두 끝난 후에 선정산이 시작됩니다. 
       <br />
      </h1>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { commaFormat } from '@/filter/number'
import { locationRedirect } from '@/util'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  data() {
    return {
      requestLoanLoading: false,
      offer: null,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('document', ['fileObj']),
    ...mapState('contract', ['limitTransaction']),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'isLoanAvailableTime',
      'investingPullRevenue',
    ]),
    ...mapGetters('evaluation', ['isExpire']),
  },
  async created() {
    _meta({
      titles: ['선정산 필요사항 체크'],
    })

    console.log('********* title', '선정산 필요사항 체크')    

    // validateUserRequirements가 리다이렉트를 수행하면 true를 반환하도록 수정
    const shouldRedirect = await this.validateUserRequirements()
    
    // 리다이렉트가 필요한 경우 여기서 중단
    if (shouldRedirect) {
      return
    }

    // 모든 요구사항이 충족된 경우에만 실행
    const contractCurrent = await this.getCurrent()
    console.log('********* contractCurrent', contractCurrent)
    if(contractCurrent?.isEarlyPaymentEnabled) {
      console.log('!!!!!!!!!!!!!!!선정산 이용 중입니다')
      await this.$router.replace('/earlypay')
    }
  },
  watch: {
    me: {
      deep: true,
      immediate: true,
      async handler() {
        
      },
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    ...mapActions('loan', [
      'addLoansOffersCurrent',
      'createLoan',
      'getLoansByOngoing',
      'getLoanAvailableTime',
    ]),
    ...mapActions('evaluation', ['addCreditEvaluations', 'isKcsAgreements', 'isHometaxAccounts', 'getCreditEvaluationsCurrent']),
    ...mapActions('kyc', ['addCdd', 'getMobileAuthUrl']),
    ...mapActions('document', ['getDocuments']),
    ...mapActions('contract', ['getLimitTransaction', 'checkExistContract', 'getCurrent']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),
    ...mapActions('evaluation', [
      'getCreditEvaluationsCurrent'
    ]),

    async validateUserRequirements() {
      try {
        // 신용평가 데이터 체크
        console.log('!!!!!!!!!!! 신용평가 여부 체크')
        const creditData = await this.getCreditEvaluationsCurrent()
        if (Object.keys(creditData).length === 0) {
          await this.$router.replace({
            path: '/factoring/confirm',
            query: { 
              next: '/earlypay-check',
              redirectPath:'/earlypay-check',
            },
          })
          return true
        }

        // 본인인증 체크
        if (!this.me) {
          await this.getMe()
        }
        if (!this.me.kyc.mobileVerificationIsDone) {
          const redirect = await this.getMobileAuthUrl({
            redirectPage: `${location.origin}/kyc/verify-id?from=earlypay-check`,
          })
          locationRedirect(redirect)
          return true
        }

        // 신분증 인증 체크
        if (!this.fileObj) {
          await this.getDocuments()
        }
        if (!this.me.kyc.idCardVerificationIsDone) {
          await this.$router.replace({
            path: '/kyc/verify-id-card',
            query: { next: '/earlypay-check' },
          })
          return true
        }

        // 주거래은행 체크
        if (!this.me.withdrawalAccount.accountNumber) {
          await this.$router.replace({
            path: '/signup/bank/withdrawal',
            query: { next: '/earlypay-check' },
          })
          return true
        }

        // 사업자등록증 체크
        if (!this.fileObj.businessLicense) {
          await this.$router.replace({
            path: '/signup/documents',
            query: { next: '/earlypay-check' },
          })
          return true
        }

        // 집금계좌 체크
        if (!this.me?.collectionAccount?.accountNumber) {
          await this.$router.replace({
            path: '/bank/collections',
            query: { next: '/earlypay-check' },
          })
          return true
        }

        // 소득증명 체크
        if (!this.fileObj?.certificateOfIncomeAmount) {
          await this.$router.replace({
            path: '/signup/certification',
            query: { next: '/earlypay-check' },
          })
          return true
        }

        // 계약서 체크
        console.log('!!!!!!!!!!! 계약서 체크', this.limitTransaction, this.limitTransaction?.contract, this.limitTransaction?.remainExpireDays )
        if (!this.limitTransaction || !this.limitTransaction.contract || this.limitTransaction.remainExpireDays<0 ) {
          console.log('!!!!!!!!!!! 계약서 문제 발생')
          await this.getLimitTransaction()
        }
        const limitTransaction2 = await this.getContractsAgreementsMyfinbizService()

        console.log('!!!!!!!!!!! limitTransaction2', limitTransaction2)

        if (
          (await this.checkExistContract(this.limitTransaction) === false) || 
          (await this.checkExistContract(limitTransaction2) === false)
        ) {
          console.log('!!!!!!!!!!! 계약서 작성 필요!!!!!!!!!!!!!!!!', limitTransaction2)
          await this.$router.replace({
            path: '/signup/limit-transaction',
            query: { next: '/loan/earlypay-check' },
          })
          return true
        }

        return false // 모든 요구사항이 충족됨
      } catch (error) {
        console.error('validateUserRequirements error:', error)
        return true // 에러 발생시 리다이렉트 필요
      }
    },
    commaFormat,
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
